module.exports = __webpack_public_path__ + "static/feature3-13fa243f86249199ca70a281d72e1815.png";